import { createAuthClient } from 'better-auth/react'

/**
 * Better Auth client. Talks same-origin to `/api/auth`, which in production is
 * reverse-proxied by a Cloudflare Pages Function to the API worker, and in dev
 * is proxied by Vite to `localhost:8787`. If `VITE_API_BASE` is set (e.g. for a
 * remote API), map `.../v1` -> `.../auth`.
 */
const baseURL = import.meta.env.VITE_API_BASE
  ? import.meta.env.VITE_API_BASE.replace(/\/v1$/, '/auth')
  : `${typeof window !== 'undefined' ? window.location.origin : 'http://localhost'}/api/auth`

export const authClient = createAuthClient({ baseURL })
